/**
 * created by Simon Zhao on 7/22/21
 * Description:
 * responsible for interacting Template configuration with server.
 * ------ maintenance history ------
 */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfig } from '@tamalelibs/models/app-config.model';
import { TemplateField } from '@tamalelibs/models/template-field.model';
import { IMDLTemplate } from '@tamalelibs/models/template-mdl.model';
import { TransportService } from '@tamalelibs/services/transport.service';

@Injectable({
    providedIn: 'root'
})
export class TemplateWebService {
    constructor(private _transportService: TransportService) { }

    getTemplateFields(typeId: string): Observable<Array<TemplateField>> {
        const headers = {
            'Content-Type': 'application/json'
        };
        let url = AppConfig.templateFieldsConfigEndPoint;
        url = url.replace('{id}', typeId);
        const params = {
        };

        const options = {
            headers: headers,
            params: params
        };

        return this._transportService.get(url, options);
    }

    getEntityFields(typeId: string): Observable<Array<TemplateField>> {
        const headers = {
            'Content-Type': 'application/json'
        };
        let url = AppConfig.entityFieldsConfigEndPoint;
        url = url.replace('{id}', typeId);
        const params = {
        };

        const options = {
            headers: headers,
            params: params
        };

        return this._transportService.get(url, options);
    }
}
